let $searchBox = $('#search-autocomplete', context);

$searchBox.once().each(function() {
  let $this = $(this);

  let options = {
    url: function(phrase) {
      return '/shop_search_suggestion?_format=json&search=' + phrase;
    },
    getValue: 'title',
    requestDelay: 200,
    list: {
      maxNumberOfElements: 6,
      showAnimation: {
        type: 'fade',
        time: 300
      },
      hideAnimation: {
        type: 'slide',
        time: 300
      }
    },
    template: {
      type: 'custom',
      method: function(value, item) {
        if (typeof item == 'string') {
          return item;
        }
        return `
        <div class="search-result">
          <a href="${item.url}">
            <img class="search-result-img" src="${item.image}" alt="">
            <div class="search-result-info">
              <strong>${item.title}</strong><br>${item.variations}
            </div>
          </a>
        </div>`;
      }
    }
  };

  $this.easyAutocomplete(options);
});
